import gql from 'graphql-tag';

const UPDATE_FAVORITE_PRODUCTS = gql`
  mutation UpdateFavoriteProduct(
    $input: UpdateListItemsInput
    $skipFavorite: Boolean!
  ) {
    updateListItems(input: $input) {
      status
      items {
        status
        item {
          id
          favorite @skip(if: $skipFavorite)
        }
      }
    }
  }
`;

export default UPDATE_FAVORITE_PRODUCTS;
